"use strict"; // @flow

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var AppProvider_1 = require("./AppProvider");

var EightBaseAppProvider =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(EightBaseAppProvider, _react_1$default$Comp);

  function EightBaseAppProvider() {
    _classCallCheck(this, EightBaseAppProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(EightBaseAppProvider).apply(this, arguments));
  }

  _createClass(EightBaseAppProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // tslint:disable
      console.error('DEPRECATION WARNING: EightBaseAppProvider has been renamed to AppProvider.'); // tslint:enabe
    }
  }, {
    key: "render",
    value: function render() {
      return react_1.default.createElement(AppProvider_1.AppProvider, Object.assign({}, this.props));
    }
  }]);

  return EightBaseAppProvider;
}(react_1.default.Component);

exports.EightBaseAppProvider = EightBaseAppProvider;